import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

export const useWorkflows = (
  params: Parameters<typeof apiClient.getWorkflows>[0]["queries"],
  options: { refetchInterval?: number },
) =>
  useQuery({
    queryKey: [
      {
        endpoint: "/api/workflow/",
        params,
      },
    ],
    queryFn: async () => {
      return await apiClient.getWorkflows({ queries: params });
    },
    select: (data) => data.results,
    ...options,
  });
